module.exports = __webpack_public_path__ + "static/denise-shante-brown-678272df05c2777d041c678f8d8a0212.jpg";